import { VENTAS } from '../actions/types';

const initialState = {
    listado: [],
    informacion: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case VENTAS.BUSCAR:
            return { ...state, listado: payload };

        case VENTAS.INFORMACION:
            return { ...state, informacion: payload };

        case VENTAS.LIMPIAR:
            return { ...state, informacion: null };

        default:
            return state;
    }
};
